export default {"src":"/_next/static/media/logo-CCA-transparent.9a81ed97.svg","height":101,"width":413,"blurWidth":0,"blurHeight":0};